import React from "react";
import Career from "../components/Career";
import ServiceHeader from "../components/ServiceHeader";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import career_img from "../static/img/service_header.jpg";

function CareerPage() {
  return (
    <>
      <Nav />
      <ServiceHeader 
        image={career_img}
        title={"Career"}
        description={"Join our team and grow with us"}
      />
      <Career />
      <Footer/>
    </>
  );
}

export default CareerPage;
